export default () => ({
	legacy: false,
	fallbackLocale: {
		"en": ["en-GB"],
		"default": ["en-GB"]
	},
	missingWarn: false,
	fallbackWarn: false,
	warnHtmlMessage: false
});
